import React, { useContext } from "react";
import { useState, useEffect } from "react";
import logoGomak from "../../assets/images/login/signin-logo.png";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./Header.css";
import ProfileImg from "../../assets/images/placeholder-image.jpg";
import { IoIosLogOut } from "react-icons/io";
import "./Header.css";
import { MdOutlineDashboard } from "react-icons/md";
import { RiMenu2Fill } from "react-icons/ri";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Link, useNavigate } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { LanguageContext } from "../LanguageContext";
import translations from "./translation.json";
import { CgProfile } from "react-icons/cg";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%",
    sm: 400,
    md: 500,
  },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "10px",
  p: 4,
};

export function Header() {
  const { language, setLanguage } = useContext(LanguageContext);
  const [matchmakerName, setMatchMakerName] = useState([]);
  const [usertype, setUserType] = useState([]);
  const [matchmakerImg, setmatchmakerImg] = useState();
  const [activeMenu, setActiveMenu] = useState(
    localStorage.getItem("activeMenu") || "dashboard"
  );

  // User info state
  const [user, setUser] = useState({ first_name: "", last_name: "" });

  // modal state
  const [open, setOpen] = useState(false);
  const handlemodalOpen = () => setOpen(true);
  const handlemodalClose = () => setOpen(false);
  // Add state to control offcanvas visibility
  const [show, setShow] = useState(false);

  // Handlers for closing and toggling the sidebar
  const handleClose = () => setShow(false);
  const handleToggle = () => setShow(!show);
  // show header only when having token
  // const token = localStorage.getItem("token");
  const token = sessionStorage.getItem("token");

  const navigate = useNavigate();

  function handleLogout() {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  }

  useEffect(() => {
    const fetchAgentData = async () => {
      try {
        const response = await axiosInstance.get("/agent/registration/", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data.status === "success") {
          setUser({
            first_name: response.data.data.first_name,
            last_name: response.data.data.last_name,
          });
        }
      } catch (error) {
        console.error("Error fetching agent data:", error);
      }
    };

    if (token) {
      fetchAgentData();
    }
  }, [token]);

  return (
    <>
      {token ? (
        <Navbar expand="lg" className="navBar" sticky="top">
          <Container>
            <Navbar.Toggle
              aria-controls="offcanvasNavbar-expand-lg"
              onClick={handleToggle}
            />
            <Navbar.Brand href="/home" className="brandLogo">
              <img src={logoGomak} alt="Logo" />
            </Navbar.Brand>

            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-lg`}
              aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
              placement="start"
              show={show}
              onHide={handleClose}
            >
              {/* <Offcanvas.Header closeButton> */}
              <Offcanvas.Header>
                <div className="offcanvasHeader headerProfileImg">
                  <p>
                    {user.first_name && user.last_name
                      ? `${user.first_name} ${user.last_name}`
                      : "Profile"}
                  </p>
                </div>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-center flex-grow-1 pe-3">
                  {/* Add onClick to close sidebar when links are clicked */}
                  <Nav.Link
                    href="/home"
                    onClick={() => {
                      handleClose();
                      setActiveMenu("dashboard");
                      localStorage.setItem("activeMenu", "dashboard");
                    }}
                    className={
                      activeMenu === "dashboard" ? "activeMenu" : "navText"
                    }
                  >
                    <span className=" fs-5">
                      {" "}
                      <MdOutlineDashboard />
                    </span>{" "}
                    {translations[language].first_menu}
                  </Nav.Link>
                  <Nav.Link
                    href="/trasactions"
                    onClick={() => {
                      handleClose();
                      setActiveMenu("transactions");
                      localStorage.setItem("activeMenu", "transactions");
                    }}
                    className={
                      activeMenu === "transactions" ? "activeMenu" : "navText"
                    }
                  >
                    <span className="fs-5">
                      <RiMenu2Fill />
                    </span>{" "}
                    {translations[language].second_menu}
                  </Nav.Link>
                  <Nav.Link
                    href="/profile-edit"
                    onClick={() => {
                      handleClose();
                      setActiveMenu("myprofile");
                      localStorage.setItem("activeMenu", "myprofile");
                    }}
                    className={
                      activeMenu === "myprofile" ? "activeMenu" : "navText"
                    }
                  >
                    <span className="fs-5">
                      <CgProfile />
                    </span>{" "}
                    {translations[language].third_menu}
                  </Nav.Link>
                </Nav>
                <Nav>
                  <div
                    className="profileResponsiveContainer"
                    style={{ display: "flex" }}
                  >
                    <div className="headerProfileImg">
                      <p className="headder-part-text">
                        {user.first_name && user.last_name
                          ? `${user.first_name} ${user.last_name}`
                          : "Profile"}
                      </p>
                    </div>
                  </div>

                  <div>
                    <Nav.Link
                      onClick={handlemodalOpen}
                      className="navText d-flex"
                      title="Logout"
                    >
                      <span className="fs-5">
                        <IoIosLogOut />
                      </span>{" "}
                      <span
                        className="logoutText"
                        style={{ marginLeft: "5px", marginTop: "3px" }}
                      >
                        {translations[language].logout}
                      </span>
                    </Nav.Link>
                  </div>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
          <Modal
            open={open}
            onClose={handlemodalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" className="headermodalTitle">
                Logout Confirmation
              </Typography>
              <Typography
                id="modal-modal-description"
                className="headermodalDesc"
              >
                Are you sure you want to logout?
              </Typography>
              <div className="headerbtnContainer">
                <Button
                  className="headermodalCancel"
                  onClick={handlemodalClose}
                >
                  Cancel
                </Button>
                <Button className="headermodalLogout" onClick={handleLogout}>
                  Log out
                </Button>
              </div>
            </Box>
          </Modal>
        </Navbar>
      ) : (
        ""
      )}
    </>
  );
}
